import type React from 'react';

import Typography from '@cobliteam/ui/components/Typography';

import cn from '../../../../utils/cn';

interface DataTableCellBaseWithContent {
  title?: never;
  titleAlt?: string;
  subtitle?: never;
  disableTitle?: boolean;
  disableSubtitle?: boolean;
  content: string | React.ReactNode;
  align?: 'left' | 'center' | 'right';
  className?: string;
}

interface DataTableCellBaseWithTitle {
  title: string;
  titleAlt?: string;
  subtitle?: string;
  disableTitle?: boolean;
  disableSubtitle?: boolean;
  content?: never;
  align?: 'left' | 'center' | 'right';
  className?: string;
}

export type DataTableProps = DataTableCellBaseWithContent | DataTableCellBaseWithTitle;

const DataTableCell = ({ title, titleAlt, subtitle, disableTitle, disableSubtitle, content, align = 'left', className }: DataTableProps) => {
  if (content && typeof content === 'object') return content;

  if (content && typeof content !== 'object')
    return (
      <Typography color='secondary' className={cn('line-clamp-1', align === 'right' && 'text-right', className)}>
        {content}
      </Typography>
    );

  return (
    <div className={cn('flex flex-col gap-1', align === 'right' && 'text-right')}>
      <Typography
        title={disableTitle ? undefined : titleAlt || title}
        color='secondary'
        variant='description-title'
        className={cn('line-clamp-1', align === 'right' && 'text-right', className)}
      >
        {title}
      </Typography>

      {subtitle ? (
        <Typography color='secondary' title={disableSubtitle ? undefined : subtitle} variant='caption-default' className={cn('line-clamp-1', align === 'right' && 'text-right')}>
          {subtitle}
        </Typography>
      ) : null}
    </div>
  );
};

export default DataTableCell;
